import {SearchPCIconBoxDefault} from "./search-pc-icon.default.box";
import {styledByTheme} from "../../../../../../themes/architecture/styled-by-theme";
import {SearchPCIconCasino777Box} from "./search-pc-icon.casino777.box";
import {SearchPCIconHarrahsBox} from "./search-pc-icon.harrahs.box";
import {SearchPCIconWSOPBox} from "./search-pc-icon.wsop.box";
import {SearchPCIconMrGreenBox} from "./search-pc-icon.mrgreen.box";

export const SearchPCIconBox = styledByTheme(SearchPCIconBoxDefault)
    .forCasino777(SearchPCIconCasino777Box)
    .forHarrahs(SearchPCIconHarrahsBox)
    .forWsop(SearchPCIconWSOPBox)
    .forMrGreen(SearchPCIconMrGreenBox)
    .forMrGreenCis(SearchPCIconMrGreenBox)
    .apply();